import { gql } from '@apollo/client';
import { workflowFragment } from '../fragments/workflows';

export const createWorkflowDraftMutation = gql`
  mutation createWorkflowDraft($workflow: WorkflowInputInput!) {
    createWorkflowDraft(workflow: $workflow) {
      ...WorkflowFragment
    }
  }
  ${workflowFragment}
`;

export const saveWorkflowDraftMutation = gql`
  mutation saveWorkflowDraft($workflow: WorkflowInputInput!) {
    saveWorkflowDraft(workflow: $workflow) {
      ...WorkflowFragment
    }
  }
  ${workflowFragment}
`;

export const deleteWorkflowDraftMutation = gql`
  mutation deleteDraft($id: Long!) {
    deleteWorkflowDraft(id: $id) {
      id
      status
    }
  }
`;

export const editJourneyNameAndDescriptionMutation = gql`
  mutation editJourneyNameAndDescription(
    $workflowId: Long!
    $workflowType: WorkflowType!
    $name: String!
    $description: String!
    $labelIds: [Long!]
  ) {
    editJourneyNameAndDescription(
      workflowId: $workflowId
      workflowType: $workflowType
      name: $name
      description: $description
      labelIds: $labelIds
    ) {
      name
      description
      labels {
        id
        name
      }
    }
  }
`;

export const cancelJourneyCampaignAlertsMutation = gql`
  mutation CancelJourneyCampaignAlerts($journeyIds: [Long!]!) {
    cancelJourneyCampaignAlerts(journeyIds: $journeyIds) {
      journeyIds
    }
  }
`;

export const rescheduleJourneyCampaignAlertsMutation = gql`
  mutation CreateAndScheduleJourneyCampaignAlertsRequest($journeyIds: [Long!]!) {
    createAndScheduleJourneyCampaignAlerts(journeyIds: $journeyIds) {
      journeyIds
    }
  }
`;
